<div class="main-container">
    <div class="table-filter-container" #filter (click)="openFilterOptions($event)" [ngClass]="{'new-filter-control': configData['productType'] === 'NEW_FILTER'}">
        <div class="table-filter-wrapper">
            <div class="imgContainer">
                <img src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,720,24,24))" />
                <!-- <img src = "./../../../../assets/icons/icons-filter.svg"/> -->
            </div>
            <div class="table-filter">{{commonData.Filter_Popup_Label | translate}} <span *ngIf="configData.showCount">({{tempValCount}})</span></div>
        </div>
    </div>
    <div id="formId" class="filter-fields-wrapper" [ngStyle]="{'display':showFilters ? 'block' : 'none'}" [ngClass]="leftt ? 'left-0' : 'left-1'">
        <div class="sidemenu-header">
            <span class="dhl-icon-column-order-cancel-v2" (click)="displayFilterContainer($event,'cancel')"></span>
          </div>
        <span class="dhl-column-Filter-v2">
            <strong>FILTERS ({{tempValCount}})</strong>
        </span>
        <span class="dhl-column-reset-v2 left-spacing-manage-column">
            <button class="dhl-reset-button-v2" (click)="clearFilters($event,'reset')">Reset</button>
          </span>
        <app-form  (form)="getForm($event)"  [configData]=configData></app-form>
        <!-- *ngIf="uploadOrderTemplate" -->
        <!-- <div class="date-filter-wrapper">
            <div class="date-departure">
                <app-form-field-input-v2 [frmGroup]="frmGroup1" [configData]="configData1"> </app-form-field-input-v2>
            </div>
            <div class="date-arrival">
                <app-form-field-input-v2 [frmGroup]="frmGroup1" [configData]="configData2"> </app-form-field-input-v2>
            </div>
        </div>
        <div class="location-filter-wrapper">
            <div class="location-origin">
                <app-form-field-input-v2 [frmGroup]="frmGroup1" [configData]="configData3"> </app-form-field-input-v2>
            </div>
            <div>
                <img src="../../../../../../assets/icons/icons-sort.svg" class="switch-icon" (click)="removeItem(item)">
            </div>
            <div class="location-destination">
                <app-form-field-input-v2 [frmGroup]="frmGroup1" [configData]="configData4"> </app-form-field-input-v2>
            </div>
        </div> -->
        <div class="action-buttons-wrapper">
          <div class="">
                <button type="button" (click)="clearFilters($event)" class="button-clear"> {{commonData.Column_Order_ClearBtn | translate}} </button>
            </div>
            <div class="">
                <button type="button" (click)="sendFilterToSource(null, $event)" class="button-apply"> {{commonData.Column_Order_ApplyBtn | translate}} </button>
            </div>

        </div>
    </div>
</div>
